import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthCard from "../components/AuthShell";
import { api } from "../lib/api";

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState("");
    const [done, setDone] = useState(false);
    const [loading, setLoading] = useState(false);

    const onSubmit = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        if (loading) return;
        setLoading(true);
        try {
            await api.post("/auth/request-password-reset", { email });
        } catch (_) {}
        setLoading(false);
        setDone(true);
    };

    return (
        <AuthCard
            title="Password dimenticata"
            subtitle="Inserisci la tua email e ti invieremo un link per reimpostarla."
            testId="forgot-shell"
        >
            {done ? (
                <>
                    <div className="el-note" data-testid="forgot-success-note">
                        Se l'indirizzo esiste, abbiamo inviato un link valido per un'ora.
                    </div>
                    <div className="el-foot">
                        <Link to="/login" data-testid="back-to-login-link">Torna ad accedi</Link>
                    </div>
                </>
            ) : (
                <form onSubmit={onSubmit} method="post" action="#" noValidate data-testid="forgot-form">
                    <label htmlFor="email" className="el-label">Email</label>
                    <input
                        id="email"
                        className="el-field"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="nome@enerleft.it"
                        autoComplete="username"
                        required
                        data-testid="forgot-email-input"
                    />

                    <button
                        type="submit"
                        className="el-btn"
                        disabled={loading}
                        onClick={onSubmit}
                        data-testid="forgot-submit-btn"
                    >
                        {loading ? "Invio…" : "Invia link"}
                    </button>

                    <div className="el-foot">
                        <Link to="/login" data-testid="forgot-back-login-link">Torna ad accedi</Link>
                    </div>
                </form>
            )}
        </AuthCard>
    );
}
